// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbs":"e_pH","shortLine":"e_qH","splitter":"e_rH","topBlock":"e_sH","topAside":"e_tH","topContent":"e_uH","contentTitle":"e_vH","splitter2":"e_wH","comments":"e_xH"};